<template>
  <label
    :class="['root', 'wrapper', {
      'wrapper_hover': inputHover,
      'wrapper_focus': inputFocus
    }]"
    @mouseover="handleMouseover"
    @mouseout="handleMouseout"
    @click="handleFocus"
  >
    <span class="label-text typ__size_sm typ__style_bold typ__style_uppercase typ__tracking_loose">{{ label }}</span>
    <input ref="field" v-if="!multiline"
      class="input typ__size_md"
      v-bind="$attrs"
      :value="value"
      v-on="inputListeners"
      @focus="handleFocus"
      @blur="handleBlur"
    >
    <div v-else class="textarea input">
      <p ref="field" class="textarea__field typ__size_md"
        contenteditable
        v-bind="$attrs"
        :value="value"
        v-on="inputListeners"
        @focus="handleFocus"
        @blur="handleBlur"></p>
      <input
        v-bind="$attrs"
        type="hidden"
        :value="value"
      />
    </div>
  </label>
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'UnderlineTextInput',
  props: {
    'multiline': Boolean,
    'label': String,
    'value': String
  },
  data: function () {
    return {
      inputHover: false,
      inputFocus: false
    }
  },
  methods: {
    handleMouseover: function () {
      this.inputHover = true
    },
    handleMouseout: function () {
      if (!this.inputFocus) this.inputHover = false
    },
    handleFocus: function () {
      this.$refs.field.focus()
      this.inputFocus = true
      this.inputHover = true
    },
    handleBlur: function () {
      this.inputFocus = false
      this.inputHover = false
    }
  },
  computed: {
    inputListeners: function () {
      return Object.assign({}, this.$listeners, {
        input: (e) => {
          const value = (!this.multiline
            ? e.target.value : e.target.textContent)

          this.$emit('input', value)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.root {
  font-size: 1rem;
}

.wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: text;

  &:before,
  &:after {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: $sz__border-width;
    will-change: transform;
    transition: transform $tm__slow-animation;
    content: "";
  }

  &:before {
    background: $clr__border;
  }

  &:after {
    background: $clr__body;
    transform: scaleX(0) translateY(0);
    transform-origin: left;
  }

  &_hover {
    &:before {
      transform: translateY(.25em);
    }

    &:after {
      transform: scaleX(0) translateY(.25em);
    }
  }

  &_focus {
    .label-text {
      color: $clr__body-dark;
    }

    &:after {
      transform: scaleX(1) translateY(.25em);
    }
  }
}

.label-text {
  display: block;
  color: $clr__body;
  transition: color $tm__slow-animation;
}

.input {
  height: 1rem;
  background: none;
}

.textarea {
  display: flex;
  align-items: flex-end;
  height: 100%;

  &__field {
    width: 100%;
    max-height: 100%;
    margin-bottom: 0;
    color: $clr__body-dark;
    overflow-y: auto;
    overflow-x: hidden;
    outline: none;
  }
}
</style>
